<script>
   /**************************************************************/
   /* Svelte component for EigenvaluesPlot settings              */
   /**************************************************************/

   import Container from '../../../shared/controls/Container.svelte';
   import Select from '../../../shared/controls/Select.svelte';
   import PlotTypeSelector from '../../../shared/controls/PlotTypeSelector.svelte';

   export let params;
   export let model;

   let plotType = 'b';
   let showLabels = 'hide';
   let transform = 'none';

   $: params = {
      plotType,
      showLabels,
      transform
   }
</script>

{#if model  }
<Container label="">
   <p class="title">Eigenvalues plot</p>
</Container>
<PlotTypeSelector bind:value={plotType} plotTypeOptions={['b', 'h']} />
<Container label='Transform:'>
   <Select id='transform' bind:value={transform} options={['none', 'sqrt', 'log']} />
</Container>
<Container label='Labels:'>
   <Select id='showLabels' bind:value={showLabels} options={['hide', 'show']} />
</Container>
{/if}
